import { createAsyncThunk } from '@ui/store/create-async-thunk';

import { deleteSnapQuotePrice } from '../endpoints/delete-snap-quote-price';
import { actions } from '../reducer';
import { selectQuoteBuilder } from '../selectors/quote-builder';

export const deleteQuotePriceOptimistically = createAsyncThunk<
  void,
  { quoteLineUuid: string; quotePriceUuid: string },
  {
    fulfilledMeta: { quoteLineUuid: string; quotePriceUuid: string };
    rejectedMeta: { quoteLineUuid: string; quotePriceUuid: string };
    rejectValue: string;
  }
>(
  'quoteBuilder/deleteQuotePriceOptimistically',
  async (
    { quoteLineUuid, quotePriceUuid },
    { getState, dispatch, fulfillWithValue, rejectWithValue },
  ) => {
    const state = getState();
    const { siteCode, uuid: quoteUuid } = selectQuoteBuilder(state);

    dispatch(
      actions.quotePriceDeleted({
        quoteLineUuid,
        quotePriceUuid,
      }),
    );

    try {
      await dispatch(
        deleteSnapQuotePrice.initiate({
          siteCode,
          quoteUuid,
          quoteLineUuid,
          quotePriceUuid,
        }),
      ).unwrap();

      return fulfillWithValue(undefined, { quoteLineUuid, quotePriceUuid });
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to delete quote price';

      return rejectWithValue(errorMessage, {
        quoteLineUuid,
        quotePriceUuid,
      });
    }
  },
);
